/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignPipelineConfigResetToDefaults } from '../../axios/campaignPipelineConfigResetToDefaults'
import type {
	CampaignPipelineConfigResetToDefaultsError,
	CampaignPipelineConfigResetToDefaultsPathParams,
	CampaignPipelineConfigResetToDefaultsRequest,
	CampaignPipelineConfigResetToDefaultsResponse,
} from '../../types/CampaignPipelineConfigResetToDefaults'

export const campaignPipelineConfigResetToDefaultsMutationKey = () =>
	[{ url: '/campaigns/:campaign/pipeline-config/reset-to-defaults' }] as const

export type CampaignPipelineConfigResetToDefaultsMutationKey = ReturnType<
	typeof campaignPipelineConfigResetToDefaultsMutationKey
>

export type CampaignPipelineConfigResetToDefaultsVariables = {
	campaign: CampaignPipelineConfigResetToDefaultsPathParams['campaign']
	data: CampaignPipelineConfigResetToDefaultsRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::resetToDefaults */
export function useCampaignPipelineConfigResetToDefaults<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignPipelineConfigResetToDefaultsResponse,
		AxiosError<CampaignPipelineConfigResetToDefaultsError>,
		CampaignPipelineConfigResetToDefaultsVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignPipelineConfigResetToDefaultsMutationKey(),
		mutationFn: ({ campaign, data }: CampaignPipelineConfigResetToDefaultsVariables) =>
			campaignPipelineConfigResetToDefaults(campaign, data, config).then(res => res.data),
		...options,
	})
}
